export default __webpack_public_path__ + "static/media/3 - Vajra.d0023c9b.mp3";